export default "__VITE_ASSET__6R4YIKFe__"